import { datadogRum } from '@datadog/browser-rum';

import type {
  ErrorContext,
  LogContext,
  Logger,
  LoggerConfig,
} from 'src/utils/logger/logger';

const loadDatadogRUM = ({
  buildVersion,
  sessionTrackingEnabled,
  environment,
  country,
}: DatadogLoggerConfig) => {
  datadogRum.init({
    applicationId: 'da9f83bd-035f-4d90-9ccb-7226340ffef1',
    clientToken: 'pub4a9f01cb27746c31f77d6878e6c5b6df',
    site: 'datadoghq.com',
    service: 'dashboard-ui',
    version: `${buildVersion}-country-${country}`,
    env: environment,
    sessionSampleRate: sessionTrackingEnabled ? 100 : 0,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: false,
    silentMultipleInit: true,
  });

  datadogRum.startSessionReplayRecording();
};

interface DatadogLoggerConfig extends LoggerConfig {
  sessionTrackingEnabled?: boolean;
}

export const createDatadogLogger = ({
  buildVersion,
  sessionTrackingEnabled = true,
  environment,
  hirerAccountId,
  userId,
  country,
}: DatadogLoggerConfig): Logger => {
  loadDatadogRUM({
    environment,
    sessionTrackingEnabled,
    buildVersion,
    country,
  });
  datadogRum.setGlobalContextProperty('sessionContext', {
    hirerAccountId,
    userId,
    'user-country': country,
  });

  return Object.freeze({
    info: (message: string, context: LogContext | undefined) =>
      datadogRum.addAction(context?.activity ?? message, {
        ...context,
        message,
      }),
    error: (message: string, context: ErrorContext | undefined) => {
      const error = context?.error ?? new Error(message);
      datadogRum.addError(error, {
        ...context,
        message,
      });
    },
  });
};
